/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { CRSFSecReviewDecisionRecord } from './CRSFSecReviewDecisionRecord';
import {
    CRSFSecReviewDecisionRecordFromJSON,
    CRSFSecReviewDecisionRecordFromJSONTyped,
    CRSFSecReviewDecisionRecordToJSON,
} from './CRSFSecReviewDecisionRecord';

/**
 * 
 * @export
 * @interface CRSFSecReviewDecisionsPagedResponse
 */
export interface CRSFSecReviewDecisionsPagedResponse {
    /**
     * 
     * @type {number}
     * @memberof CRSFSecReviewDecisionsPagedResponse
     */
    page?: number;
    /**
     * 
     * @type {number}
     * @memberof CRSFSecReviewDecisionsPagedResponse
     */
    page_size?: number;
    /**
     * 
     * @type {Array<CRSFSecReviewDecisionRecord>}
     * @memberof CRSFSecReviewDecisionsPagedResponse
     */
    results?: Array<CRSFSecReviewDecisionRecord>;
    /**
     * 
     * @type {number}
     * @memberof CRSFSecReviewDecisionsPagedResponse
     */
    total?: number;
}

/**
 * Check if a given object implements the CRSFSecReviewDecisionsPagedResponse interface.
 */
export function instanceOfCRSFSecReviewDecisionsPagedResponse(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function CRSFSecReviewDecisionsPagedResponseFromJSON(json: any): CRSFSecReviewDecisionsPagedResponse {
    return CRSFSecReviewDecisionsPagedResponseFromJSONTyped(json, false);
}

export function CRSFSecReviewDecisionsPagedResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): CRSFSecReviewDecisionsPagedResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'page': !exists(json, 'page') ? undefined : json['page'],
        'page_size': !exists(json, 'page_size') ? undefined : json['page_size'],
        'results': !exists(json, 'results') ? undefined : ((json['results'] as Array<any>).map(CRSFSecReviewDecisionRecordFromJSON)),
        'total': !exists(json, 'total') ? undefined : json['total'],
    };
}

export function CRSFSecReviewDecisionsPagedResponseToJSON(value?: CRSFSecReviewDecisionsPagedResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'page': value.page,
        'page_size': value.page_size,
        'results': value.results === undefined ? undefined : ((value.results as Array<any>).map(CRSFSecReviewDecisionRecordToJSON)),
        'total': value.total,
    };
}

